const PriceFormatter = (price, params = {'multiplier' : 1, 'discount_percentage' : 0, 'contents_protection' : 0}) => {
  let multiplier = params.multiplier || 1;
  let contents_prot = params.contents_protection || 0;
  let dscntPercentage = params.discount_percentage || 0;

  let caclulatedPrice = (parseFloat(price) + parseFloat(contents_prot)) * multiplier;

  let finalPrice = dscntPercentage === 0 ? caclulatedPrice : caclulatedPrice * (dscntPercentage / 100);

  return finalPrice.toFixed(2);
};

export default PriceFormatter;
